
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import editar_envio from './barra-ventas-editar-envio.vue';
    import declaracion from './barra-ventas-subir-declaracion.vue';
    import detalles from './barra-ventas-pedidos-detalles.vue';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Chat } from '@/__env/lib/MercadoLibre/Chats';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        @Prop()
        public Chat: Chat;


        public Pedidos: Pedido[] = [];

        public SoloPendientes: boolean = false;
        @Watch( 'SoloPendientes' )
        onSoloPendientes()
        {
            this.Iniciar();
        }

        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            //this.Iniciar();
        }

        async Iniciar()
        {
            this.Cargando = true;
            this.Pedidos.clear();
            let bb: any = { cliente: this.Chat.Cliente.Id, order: 'fecha', sort: 'DESC' };
            if ( this.SoloPendientes )
            {
                bb.tags = 'pendientes';
            }

            let e = await Pedido.find( bb );
            if ( e.Items.hasRows() )
                this.Pedidos = e.Items;
            this.Cargando = false;
        }







        Cerrar()
        {

        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
